import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AsideNav from "./root/AsideNav";
import { IoIosLogOut } from "react-icons/io";
import { toast } from "react-toastify";
import "./AgencyDashboard.css";
import LocationApp from "../../sharedComponents/Location/LocationApp";
import UserTokenHandler from "../../sharedComponents/UserTokenHandler";
import GetLocalStorageUserId from "../../sharedComponents/GetLocalStorageuserId";
import { redirectToIdentityLogin } from "../../../utils/identityLogin";
const AgencyDashboard = () => {
  const [userId, setUserId] = useState(null);
  UserTokenHandler();
  useEffect(() => {
    setUserId(GetLocalStorageUserId());
  }, []);

  const move = useNavigate();
  const logoutHandle = () => {
    toast.success("Logout Successfull", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
    localStorage.removeItem("sundorbonBookingUserDetails");
    localStorage.removeItem("token");
    localStorage.removeItem("Sundarbantoken");
    move("/");
  };

  const handleLoginClick = () => {
    redirectToIdentityLogin(window.location.origin);
  };
  return (
    <div className="bg-[#FFFDE7] ">
      {userId ? (
        <button
          onClick={logoutHandle}
          className="lg:flex hidden absolute z-30 top-3 right-5 items-center gap-2 font-medium lg: mt-4 text-lg bg-gradient-to-tr from-[#6D4C41] rounded-[8px] h-[47px] px-3 to-[#424242] text-white"
        >
          Logout <IoIosLogOut className="text-xl" />
        </button>
      ) : (
        <button
          className="lg:flex hidden absolute top-3 right-5 z-30 items-center gap-2 font-medium lg:mt-4 text-lg bg-gradient-to-tr from-[#6D4C41] rounded-[8px] h-[47px] px-3 to-[#424242] text-white"
          onClick={handleLoginClick}
        >
          Login
        </button>
      )}
      <LocationApp />
      <div className="min-h-screen lg:pt-6 xl:gap-x-[50px] lg:gap-[20px] flex lg:flex-row flex-col items-start ">
        <AsideNav></AsideNav>

        <div className="w-full relative z-10 lg:w-[75%] xl:w-[80%] pt-8 lg:pt-[100px] lg:px-[0px] min-h-screen">
          <Outlet></Outlet>
        </div>
      </div>
    </div>
  );
};

export default AgencyDashboard;
